<button
    class="join-chat-button"
    mat-flat-button
    color="primary"
    (click)="navigateToChat(chatId); $event.stopPropagation()"
>
    {{ text | transloco }}
</button>
